import { render, staticRenderFns } from "./ViewMessageModal.vue?vue&type=template&id=13ed337a&scoped=true&"
import script from "./ViewMessageModal.vue?vue&type=script&lang=js&"
export * from "./ViewMessageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ed337a",
  null
  
)

export default component.exports